import { render } from "./GeofenceConfiguration.vue?vue&type=template&id=1528d640&scoped=true"
import script from "./GeofenceConfiguration.vue?vue&type=script&lang=js"
export * from "./GeofenceConfiguration.vue?vue&type=script&lang=js"

import "./GeofenceConfiguration.vue?vue&type=style&index=0&id=1528d640&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1528d640"]])

export default __exports__